import { Capacitor } from '@capacitor/core';

export function isNativePlatform() {
    return Capacitor.isNativePlatform();
}

export function getNativePlatform() {
    return Capacitor.getPlatform();
}

export function isAndroidNative() {
    return isNativePlatform() && getNativePlatform() === 'android';
}
